export default __webpack_public_path__ + "fd1668e742915c48ace6f5160af09310.svg";